import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 9 6",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.33203 6L0.00190401 0H8.66216L4.33203 6Z" })
});
export default SvgArrowDown;
